import Dropdown from "./ui/Dropdown"
import { useSnapshot } from "valtio"
import { state, configuratorState, setDimension, setInitialised, setUsecase, setShedSize, setLastShedSize } from "../state"
import Button from "./ui/configurator/Button"
import { useEffect, useState } from "react"

import { styled } from '@mui/material/styles';
import { ListAcordion } from "./ui/ListAcordion"
const SampleImage = () =>{
    return(
        <img style={{padding:'5%'}} id="sample" src="images/Bin Store.png"/>
    )
} 

const ConfiguratorInitialiserOptions = () => {
    const {dimension, lastShedSize} = useSnapshot(state);
    const [expanded, setExpanded]  = useState(false);
    const [showSizes, setShowSizes] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const handleChange = (panel) =>
            (isExpanded) => { setExpanded(isExpanded ? panel===expanded?false: panel :  false);};
    useEffect(()=>{
        setDimension(dimension);
        setShedSize(lastShedSize)
    },[])

    return(
        <div id="options">
        <div className="details-options" style={{marginBottom:"12px"}}>
            <ListAcordion expanded={expanded === 'panel1'} toggle={()=>handleChange('panel1')} label={"Storage Type"}><Usecases handleClick={()=>{setShowSizes(true); setShowConfirm(true); setExpanded('panel2')}}/></ListAcordion>
            <ListAcordion expanded={expanded === 'panel2'} visibility={showSizes ? 'visible' : 'hidden'} toggle={()=>handleChange('panel2')} label={"Sizes"}><Sizes handleClick={()=>{setExpanded(false)}}/></ListAcordion>
        </div>
        <div style={{textAlign:"right", overflowY:"scroll"}}>
        <Button rightAlign={true} id="confirmButton" label = {"Confirm Selection"} visibility={showConfirm ? 'visible' : 'hidden'} image ={false} value={"confirmButton"} primary = {false} large ={false} confirm={true} onClick={()=>setInitialised(true)}/>
        </div>
        </div>
    )
}

const Sizes = (props) => {
    const {dimensions, usecase, dimension} = useSnapshot(state);
    const [sizes, setSizes] = useState([]);
    const handleClick = (dimension, shed, close = true) => {
        setDimension(dimension)
        setShedSize(shed)
        setLastShedSize(shed);
        close?props.handleClick():null;
    }
    
    useEffect(()=>{
        let defaultSize = [24,26];
        if(usecase!=="Empty"){
            const sizes = dimensions.filter(d=>d.usecases.find(use=>use.use===usecase));
            defaultSize = sizes[0].dimension;
        }
        handleClick(defaultSize,[(defaultSize[1]-2)/12, defaultSize[0]/12], false);
    },[usecase])
    
    if(usecase==="Bin") return(
        dimensions.filter(d=>d.usecases.some(use=>use.use===usecase)).map((data,index)=>
            <Button
                light={true}
                isSelected={data.dimension[0]===dimension[0] &&data.dimension[1]===dimension[1]}
                onClick = {() =>handleClick(data.dimension, [(data.dimension[1]-2)/12, data.dimension[0]/12])}
                key={index}
                large={true} 
                primary={true}
            >
            <span>{`${getUsecaseObject(usecase,data.usecases).code} ${data.dimension[0]}.${data.dimension[1]} - ${(data.width/1000).toFixed(1)}x${(data.depth/1000).toFixed(1)}m`}<sup>2</sup></span>
            </Button>
        )
    )
    
    else if(usecase!=="Empty") return(
        dimensions.filter(d=>d.usecases.some(use=>use.use===usecase)).map((data,index)=>
            <Button
                light={true}
                isSelected={data.dimension[0]===dimension[0] &&data.dimension[1]===dimension[1]}
                onClick = {() =>handleClick(data.dimension, [(data.dimension[1]-2)/12, data.dimension[0]/12])}
                key={index}
                large={true} 
                primary={true}
            >
            <span>{`${getUsecaseObject(usecase,data.usecases).code} ${data.dimension[0]}.${data.dimension[1]} - ${getUsecaseObject(usecase,data.usecases).capacity} - ${(data.width/1000).toFixed(1)}x${(data.depth/1000).toFixed(1)}m`}<sup>2</sup></span>
            </Button>
        )
    )

    else return(
        dimensions.map((data,index)=>
            <Button
                light={true}
                isSelected={data.dimension[0]===dimension[0] &&data.dimension[1]===dimension[1]}
                onClick = {() =>handleClick(data.dimension, [(data.dimension[1]-2)/12, data.dimension[0]/12])}
                key={index}
                large={true} 
                primary={true}
            >
                <span>{`PTH ${data.dimension[0]}.${data.dimension[1]} - ${(data.width/1000).toFixed(1)}x${(data.depth/1000).toFixed(1)}m`}<sup>2</sup></span>
                </Button>
        )
    )
}

const getUsecaseObject = (usecase, usecases) => {
    let temp;
    
    for(let i =0; i<usecases.length; i++){
        if(usecases[i].use === usecase){
            temp = usecases[i];
            break;
        }
    }
    return temp;
}
const Usecases = (props) => {
    const {usecases,usecase} = useSnapshot(state);
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel) => (isExpanded) => {
      setExpanded(isExpanded ? panel===expanded?false: panel :  false);
    };
    return(
        usecases.map((use,index)=>
            use.children===null?
            <Button 
                label={"Bin Store"} 
                key={use.name+index} 
                large={true}
                primary={true} 
                light={true} 
                onClick={()=>{setUsecase(use.name); props.handleClick(); setExpanded(false)}}
                isSelected={use.name===usecase}
            />:
            <ListAcordion 
                key={index}
                active={use.children.some((el)=>el.name===usecase)}
                label={"Cycle Store"} 
                child={"true"} 
                light={"true"} 
                expanded={expanded === 'panel1'} 
                toggle={()=>handleChange('panel1')} 
            >
                    <ChildUseCases handleClick={props.handleClick} children={use.children}/>
            </ListAcordion>    )
    )
}

const ChildUseCases = ({children, handleClick}) => {
    const {usecases,usecase} = useSnapshot(state);
    return(
        <div className="horizontal-options-left">
             {children.map((value, index) => {
                return (
                    <Button 
                        key={value.name +index}
                        leftAlign={true} 
                        id={`usecase${index}Button`}
                        variableSize={true}
                        label = {value.name}  
                        image ={false} 
                        value={value.name} 
                        large ={false} 
                        onClick={()=>{setUsecase(value.name); handleClick()}}
                        selected={usecase === value.name}
                    />
                )}
            )}
        </div>
    )
}

const ConfiguratorInitialiser = () => {
    return(
        <div style={{display:"flex",maxHeight:"100%",flex:1, overflow:"hidden", margin:"20px 110px 110px 110px"}}>
            <SampleImage/>
            <ConfiguratorInitialiserOptions/>
        </div>
    )
}

export default ConfiguratorInitialiser